export default __webpack_public_path__ + "static/media/InStep-Health-logo-stacked.4a586b56.svg";